import React from 'react';
import { Link } from 'react-router-dom';

const OrderConfirmation: React.FC = () => (
  <div className="max-w-lg mx-auto mt-12 bg-white p-8 rounded shadow text-center">
    <h2 className="text-2xl font-bold mb-4 text-green-700">Thank you for your order!</h2>
    <p>Your payment was successful and we will ship your order soon.</p>
    <Link to="/puzzles" className="text-orange font-bold">Continue Shopping</Link>
  </div>
);

export default OrderConfirmation; 